import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import DefaultApiService from "../../../../infrastructure/api/default";
import { ReactComponent as PdfIcon } from "../../../assets/icons/pdf.svg";

const ExportPdfButton = ({ exportApi, filterValues }) => {
  const [loading, setLoading] = useState(false);

  const onGetExport = async () => {
    try {
      setLoading(true);
      const result = await DefaultApiService.postApi(
        exportApi + "/ExportPdf",
        filterValues
      );
      setLoading(false);

      if (result.isSuccess && result?.data?.link) {
        window.open(result?.data?.link, "_blank");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoadingButton
        variant="outlined"
        color="danger"
        startIcon={<PdfIcon width={16} height={16} />}
        onClick={onGetExport}
        loading={loading}
      >
        PDF
      </LoadingButton>
    </Box>
  );
};

export default ExportPdfButton;
